import React, { Component } from 'react';
import http from '../api';

import x_img from '../../../resources/img/x.svg';
import CardIcon from '../common/CardIcon';

import * as StringUtil from '../utils/StringUtil';

// var calc_payment = false;
// var fromExpect = false;
var pf = null;
var isPayLinkClick = false;
class PersonalPaymentCompletePopup extends Component {

constructor(props) {
    super(props);
    this.state = {
        userPersonalOrderPrice : {},
        payLinkPreData : {},
    }
}

componentDidMount() {
    // this.loadUserPersonalOrderPrice();
    this.deleteUserPersonalOrderPrice();
}

componentDidUpdate() {
}

deleteUserPersonalOrderPrice() {
    http.post('/rest/shop/deletePersonalPayment').then((res) => {
        console.log(res);
    });
}

 render() {
    const { isPopup, isClose, onClose, onConfirm } = this.props; // 팝업 여부 prop 전달
    return (
        <>
            <div
                id="personal-payment-complete"
                className={`payment-complete-box ${isPopup ? 'popup-mode' : ''}`}
                >
                {/* 닫기 버튼 */}
                {isClose && (
                    <button className="close-button" onClick={onClose}>
                    <img src={x_img} alt="닫기 버튼" />
                    </button>
                )}

                <div className="icon-wrap">
                    <div className="check-icon"></div>
                </div>

                <p className="message">
                    <strong>결제</strong>가 완료되었습니다.
                </p>

                <button className="confirm-button" onClick={onConfirm ? onConfirm : (() => window.location.href="/")}>확인</button>
            </div>
        </>
    );
  }
}

export default PersonalPaymentCompletePopup;